package scenes.test

import com.soywiz.korge.input.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.ui.*
import com.soywiz.korge.view.*
import com.soywiz.korim.format.*
import com.soywiz.korio.file.std.*
import scenes.*
import utils.*

class MainTestScene : Scene() {
    val buttonsMargin = 16
    val buttonWidth = 256
    val buttonHeight = 32

    override suspend fun SContainer.sceneInit() {

        container {
            val loadedImg = resourcesVfs["background/Green.png"].readBitmap()
            val bgImgCountX = GameDimensions.V_WIDTH / 64
            val bgImgCountY = GameDimensions.V_HEIGHT / 64
            for (i in 0..bgImgCountX) {
                for (j in 0..bgImgCountY) {
                    image(loadedImg) {
                        position(
                            0 + i * 64,
                            0 + j * 64
                        )
                    }
                }
            }

            val multiplayerButton = multiplayerButton()
            val singlePlayerButton = singlePlayerButton(multiplayerButton)
            val box2dSeparated = box2dSeparatedButton(singlePlayerButton)

            versionText()

            testAnimation()
        }
    }

    private suspend fun Container.testAnimation() {
        val spriteMap = resourcesVfs["characters/ninja_frog/run.png"].readBitmap()
        val runAnimation = SpriteAnimation(
            spriteMap = spriteMap,
            spriteWidth = 32,
            spriteHeight = 32,
            marginTop = 0,
            marginLeft = 0,
            columns = 12,
            rows = 1,
            offsetBetweenColumns = 0,
            offsetBetweenRows = 0,
        )

        val runSprite = sprite(runAnimation)
        runSprite.playAnimationLooped()

        val spriteMapLeft = resourcesVfs["characters/ninja_frog/run.png"].readBitmap().flipX()

        image(spriteMapLeft).position(0, 96)

        val runAnimationLeft = SpriteAnimation(
            SpriteAnimation(
                spriteMap = spriteMapLeft,
                spriteWidth = 32,
                spriteHeight = 32,
                marginTop = 0,
                marginLeft = 0,
                columns = 12,
                rows = 1,
                offsetBetweenColumns = 0,
                offsetBetweenRows = 0,
            ).reversed()
        )

        val runSpriteLeft = sprite(runAnimationLeft).position(0, 48)
        runSpriteLeft.playAnimationLooped()

        val idleMap = resourcesVfs["characters/ninja_frog/idle.png"].readBitmap()
        val idleAnimation = SpriteAnimation(
            spriteMap = idleMap,
            spriteWidth = 32,
            spriteHeight = 32,
            marginTop = 0,
            marginLeft = 0,
            columns = 11,
            rows = 1,
            offsetBetweenColumns = 0,
            offsetBetweenRows = 0,
        )

        val idleSprite = sprite(idleAnimation).position(48, 0)
        idleSprite.playAnimationLooped()

//        val atlas = resourcesVfs["characters/ninja-frog/run.atlas.json"].readAtlas()
//
//        val atlasRunAnimation = atlas.getSpriteAnimation(prefix = "characters/ninja-frog/run.png")
//        sprite(atlasRunAnimation).position(96, 0).playAnimationLooped()
    }

    private fun Container.multiplayerButton() = uiButton(
        label = "Сетевая игра",
        width = 256.0,
        height = 32.0
    ) {
        position(
            GameDimensions.V_WIDTH / 2 - 256 / 2,
            GameDimensions.V_HEIGHT / 2 - 32 / 2
        )
        onClick {
            sceneContainer.changeTo<MultiplayerRunScene>()
        }
        enable()
    }

    private fun Container.singlePlayerButton(
        playButton: UIButton
    ) = uiButton(
        label = "Одиночная игра",
        width = 256.0,
        height = 32.0
    ) {
        position(
            playButton.x.toInt(),
            playButton.y.toInt() + buttonHeight + buttonsMargin
        )
        onClick {
            sceneContainer.changeTo<SinglePlayerScene>()
        }
        enable()
    }

    private fun Container.box2dSeparatedButton(
        playButton: UIButton
    ) = uiButton(
        label = "Box2d отдельно",
        width = 256.0,
        height = 32.0
    ) {
        position(
            playButton.x.toInt(),
            playButton.y.toInt() + buttonHeight + buttonsMargin
        )
        onClick {
            sceneContainer.changeTo<Box2dScene>()
        }
        enable()
    }

    private fun Container.versionText() = uiText(
        text = "v ${Constants.VERSION}",
        width = 128.0,
        height = 18.0
    ) {
        position(
            8,
            GameDimensions.V_HEIGHT - 8 - 18
        )
    }
}
